<template>
  <div class="lineup-item">
    <div class="lineup-item__thumbnail">
      <a :href="item.link" class="lineup-item__anchor" target="_blank">
        <img
          :src="`/theme/rbFront/img/w/magnit/contents/LineUp/${item.thumbnail}`"
          alt=""
        />
      </a>
    </div>
    <div class="lineup-item__header">
      <div class="lineup-item__modelname">{{ item.modelname }}</div>
      <div class="lineup-item__dimension">
        <a
          v-for="(dimension, index) in item.dimension"
          :key="`dimension-${index + 1}`"
          :href="`${dimension.link}`"
          target="_blank"
          class="lineup-item__button"
          @click="$emit('click', dimension)"
        >
          {{ dimension.label }}
        </a>
      </div>
    </div>
    <ul class="lineup-item__features">
      <li
        v-for="(feature, index) in item.features"
        :key="`feature-${index + 1}`"
        class="lineup-item__feature"
      >
        {{ feature }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'LineUpItem',
  props: {
    item: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  methods: {
    // handleClick() {
    //   this.$emit('click')
    // },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
.lineup-item {
  width: 400px;
  height: 423px;
  background-color: #fff;
  border-radius: 30px;
  padding: 0 40px;
  box-sizing: border-box;
  &__thumbnail {
    font-size: 0;
    text-align: center;
    img {
      max-width: 100%;
      margin: 0 auto;
    }
  }
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
  }
  &__modelname {
    font-size: 24px;
    font-weight: 400;
  }
  &__dimension {
    display: flex;
    gap: 10px;
  }
  &__button {
    height: 32px;
    line-height: 32px;
    font-size: 22px;
    font-weight: 400;
    background-color: #fd312e;
    color: #fff;
    text-align: center;
    border-radius: 16px;
    padding: 0 17px;
  }
  &__features {
    margin-top: 14px;
    border-top: solid 0.5px #000;
    padding-top: 14px;
    line-height: 26px;
  }
  &__feature {
    position: relative;
    display: flex;
    font-size: 18px;
    font-weight: 400;
    &::before {
      content: '';
      display: block;
      width: 6px;
      height: 6px;
      background: url(/theme/rbFront/img/w/magnit/dot.png) left top no-repeat;
      margin-top: 10px;
      margin-right: 9px;
    }
  }
  @media screen and (max-width: 1080px) {
    width: 100%;
    height: auto;
    min-height: 300px;
    padding: 0 calcQuarter(100) calcQuarter(60);
    border-radius: calcQuarter(30);
    &__modelname {
      font-size: calcQuarter(56);
    }
    &__dimension {
      gap: calcQuarter(24);
    }
    &__button {
      font-size: calcQuarter(54);
      height: calcQuarter(80);
      line-height: calcQuarter(80);
      padding: 0 calcQuarter(42);
    }
    &__features {
      margin-top: calcQuarter(38);
      padding-top: calcQuarter(36);
      line-height: calcQuarter(64);
    }
    &__feature {
      font-size: calcQuarter(48);
      &::before {
        width: 4px;
        height: 4px;
        margin-top: calcQuarter(20);
        margin-right: calcQuarter(21);
        background-size: 100% 100%;
      }
    }
  }
}
</style>
